module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c2wo8"))).then(() => parcelRequire('hEqeo'));